//
import CustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'
import print from './print'

/**
 * 
 */
const includes = [
    'pos_cash_desk.g_branch_office',
    'g_user.hr_employee',
    'sl_ground_seller_payment_record.sl_ground_seller.hr_employee',
    'sl_ground_seller_payment_record.sl_customer.pch_payment_condition',
    'sl_ground_seller_payment_record.sl_customer.sl_customer_account',
    'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_invoice',
    'sl_customer.sl_customer_account',
    'sl_customer.sl_ground_seller.hr_employee.g_user',
    'pos_detail_customer_receivable_payments.sl_customer_account_movement.sl_type_customer_account_movement',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_invoice',
    'payments',
]

/**
 * 
 */
const fetchBy = async ( field, value ) => {

    //
    try {

        //
        const response = await CustomerReceivablePaymentModel.include( includes ).where( field, value ).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default {
    fetchBy,
    print,
}
